import React from 'react';
import { Badge } from 'react-bootstrap';

import AutofacturacionTicketStatus from '../../enum/AutofacturacionTicketStatus';

const RenderItemStatus = ({ item }) => {
  let variant = 'light';

  let status = AutofacturacionTicketStatus.search(item.status);

  if (!status) {
    status = AutofacturacionTicketStatus.search(999);
  }

  if (status.isSuccess()) {
    variant = 'success'
  } else if (status.isFpg()) {
    variant = 'warning';
  } else if (status.isError() || status.isFailed()) {
    variant = 'danger';
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={ variant }>{ status.getName() }</Badge>
}

export default RenderItemStatus;